module.exports = __webpack_public_path__ + "static/media/projectIcon.4e213a56.png";